// Formy gramatyczne zależne od płci dziecka. Rodzic ustawia ją w profilu (chłopiec / dziewczynka); teksty zapisujemy jednym zapisem z klamrami:
//   „Skończył{eś|aś} dzisiejszą lekcję.”  →  chłopiec: „Skończyłeś…”, dziewczynka: „Skończyłaś…”
// Klamra `{M|Ż}` ma dokładnie dwie części rozdzielone kreską: pierwsza to forma męska, druga żeńska. Brak ustawionej płci (profil sprzed patcha-31,
// tryb lokalny bez kont) = forma męska, jak na makietach.

export type Gender = 'm' | 'f' | '';

export const GENDERS = ['m', 'f'] as const;

/** Poprawna płeć albo '' (nie ustawiono); `null` = nieprawidłowa wartość. */
export function cleanGender(v: unknown): Gender | null {
  if (v === undefined || v === null || v === '') return '';
  return v === 'm' || v === 'f' ? v : null;
}

const FORMS = /\{([^{}|]*)\|([^{}|]*)\}/g;
// Starszy zapis ze skośnikiem („szczęśliwy/a”, „zasłużyłeś/aś”, „zrobił/a”) — treść zapisana na serwerze przed patchem-31 albo wpisana w panelu rodzica po staremu.
// Rozpoznajemy go tak samo jak klamrę, żeby dziecko nie zobaczyło „szczęśliwy/a”: tylko dla końcówek -y/-i/-ł + „/a” oraz -eś + „/aś” (nie rusza „tak/nie”, „km/h”).
const LEGACY_A = /(\p{L}+?)(y|i|ł)\/a(?![\p{L}\/])/gu;
const LEGACY_AS = /(\p{L}*)eś\/aś(?![\p{L}\/])/gu;

/** Podstawia formy w tekście z klamrami `{eś|aś}` (i starym zapisem `eś/aś`) wg płci. */
export function forGender(text: string, gender: Gender): string {
  const f = gender === 'f';
  return text
    .replace(LEGACY_AS, (_all, stem: string) => `${stem}${f ? 'aś' : 'eś'}`)
    .replace(LEGACY_A, (_all, stem: string, end: string) => (f ? `${stem}${end === 'ł' ? 'ła' : 'a'}` : `${stem}${end}`))
    .replace(FORMS, (_all, m: string, fem: string) => (f ? fem : m));
}

/** Czy tekst ma jeszcze nierozwiązaną klamrę (do testów treści). */
export const hasForms = (text: string): boolean => /\{[^{}]*\|[^{}]*\}/.test(text);
